import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  return <AnimatePresence data-id="element-119">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-charcoal/60 backdrop-blur-sm" onClick={onClose} data-id="element-120">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="bg-cream rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-121">
            <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200 bg-white" data-id="element-122">
              <h2 className="text-2xl font-serif font-bold text-charcoal" data-id="element-123">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-124">
                <XIcon className="w-5 h-5 text-charcoal" data-id="element-125" />
              </button>
            </div>
            <div className="overflow-y-auto px-6 py-6 text-gray-700 leading-relaxed space-y-4 text-base" data-id="element-126">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}